// extracted by mini-css-extract-plugin
export default {"text_style":"style_text_style__APrVu","custompicker":"style_custompicker__I+iam"};